import { IconButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ColumnDef, useColumnFilterContext } from "../../Utils/useColumnFilters";

type Props = {
  colDef: ColumnDef;
};

export default function ColumnFilterHeader({ colDef }: Props) {
  const { openFilter, isColumnFiltered } = useColumnFilterContext();

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {colDef.label}
      <IconButton
        size="small"
        style={{ padding: 2 }}
        onClick={(e) => {
          e.stopPropagation();
          openFilter(e, colDef);
        }}
      >
        <FilterListIcon
          fontSize="small"
          style={{
            color: isColumnFiltered(colDef.urlParam) ? "#FF6633" : "rgba(0,0,0,0.38)",
          }}
        />
      </IconButton>
    </div>
  );
}
